import React, { useRef, useState, useEffect } from 'react';

import styles from "./TransactionsMain.module.css";

import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import greater from "../../../assets/images/greater.svg";
import greater2 from "../../../assets/images/greater2.svg";
import confirmation from "../../../assets/images/confirmation.svg";
import cancel from "../../../assets/images/cancel.svg";
import print from "../../../assets/images/print.svg";

import { allApplicationsApi } from "../../../config/allApplicationsApi";
import { updateApplicationApi } from "../../../config/updateApplicationApi";

import moment from "moment";
import { BiDotsVerticalRounded } from "react-icons/bi";

import { Link, useHistory } from "react-router-dom";


import {
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
} from "mdbreact";

import Tooltip from "@material-ui/core/Tooltip";

import ReactToPrint from 'react-to-print';
import { useReactToPrint } from 'react-to-print';

function TransactionsMain() {


  const [toggleState, setToggleState] = useState(0);
  const [loader, setLoader] = useState(true);
  // const [loader, setLoader] = useState(false);

  const [allTransactions, setAllTransactions] = useState([]);
  const [completed, setCompleted] = useState([]);
  const [pending, setPending] = useState([]);
  const [canceled, setCanceled] = useState([]);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const allTabs = [
    { name: "All transaction" },
    { name: "Completed" },
    { name: "Pending" },
    { name: "Canceled" },
  ];
  const allConts = [
    { app: allTransactions, error: "No Transactions Available." },
    { app: completed, error: "No Transactions Was Completed." },
    { app: pending, error: "No Transactions Is Pending." },
    { app: canceled, error: "No Transactions Was Canceled." },
  ];
  useEffect(() => {
    function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) {
        return null;
      }

      const item = JSON.parse(itemStr);
      const now = new Date();

      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
      }

      const allApplications = async (token) => {
        const allapplications = await allApplicationsApi(token);

        if (allapplications.data) {
          console.log(allapplications.data.data);

          const Applications = await allapplications.data.data;
          Applications.reverse();

          setAllTransactions([]);
          setPending([]);
          setCompleted([]);
          setCanceled([]);
          Applications.map((value, index) => {
            if (value.status !== "CANCELLED") {
              if (value.payment_status === "PAID") {
                setAllTransactions((allTransactions) => [
                  ...allTransactions,
                  {
                    country: value.destination.display_name,
                    id: value.payment_details.receipt._id,
                    date: value.created_at,
                    cost: value.cost.total_cost,
                    payment: value.payment_gateway,
                    status: value.payment_status,
                  status2: value.status,
                  },
                ]);
                setCompleted((completed) => [
                  ...completed,
                  {
                    country: value.destination.display_name,
                    id: value._id,
                    date: value.created_at,
                    cost: value.cost.total_cost,
                    payment: value.payment_gateway,
                    status: value.payment_status,
                  status2: value.status,
                  },
                ]);
              } else if (value.payment_status === "UNPAID") {
                setAllTransactions((allTransactions) => [
                  ...allTransactions,
                  {
                    country: value.destination.display_name,
                    id: value._id,
                    date: value.created_at,
                    cost: value.cost.total_cost,
                    payment: value.payment_gateway,
                    status: value.payment_status,
                  status2: value.status,
                  },
                ]);
                setPending((pending) => [
                  ...pending,
                  {
                    country: value.destination.display_name,
                    id: value._id,
                    date: value.created_at,
                    cost: value.cost.total_cost,
                    payment: value.payment_gateway,
                    status: value.payment_status,
                  status2: value.status,
                  },
                ]);
              }
            } else {
              setAllTransactions((allTransactions) => [
                ...allTransactions,
                {
                  country: value.destination.display_name,
                  id: value._id,
                  date: value.created_at,
                  cost: value.cost.total_cost,
                  payment: value.payment_gateway,
                  status: value.payment_status,
                  status2: value.status,
                },
              ]);
              setCanceled((canceled) => [
                ...canceled,
                {
                  country: value.destination.display_name,
                  id: value._id,
                  date: value.created_at,
                  cost: value.cost.total_cost,
                  payment: value.payment_gateway,
                  status: value.payment_status,
                  status2: value.status,
                },
              ]);
            }
          });
          setLoader(false);
        } else if (allapplications.error) {
          console.log(allapplications.error);
          setLoader(false);
        }
      };
      allApplications(item.value.token);
    }
    getWithExpiry("userData");
  }, []);

  return (
    <>
      {loader ? (
        <>
          <h2 className={styles.head}>Transactions</h2>
          <div className={styles.loader}>
            <div className="spinner-border" role="status"></div>
          </div>
        </>
      ) : (
        <div className={styles.container}>
          <h2 className={styles.head}>Transactions</h2>
          <div className={styles.bloctabs}>
            {allTabs.map((value, index) => (
              <button
                key={index}
                className={
                  toggleState === index ? styles.activetabs : styles.tabs
                }
                onClick={() => toggleTab(index)}
              >
                {value.name}
              </button>
            ))}
          </div>

          <div className={styles.contenttabs}>
            {allConts.map((value, index) => (
              <div
                key={index}
                className={
                  toggleState === index ? styles.activecontent : styles.content
                }
              >
                <Tableone data={value.app} error={value.error} />
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}

export default TransactionsMain;

function Tableone(props) {

  const printRef = useRef()

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  const [loading, setLoading] = useState(false);

  const history = useHistory();

  const data = props.data;
  const error = props.error;

  const [loader1, setLoader1] = useState(true);

  const cancelTRansaction = (id) => {
    setLoading(true);

    function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) {
        return null;
      }

      const item = JSON.parse(itemStr);
      const now = new Date();

      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
      }

      const updateApplication = async (token) => {
        const update = await updateApplicationApi(id, token);

        if (update.data) {
          console.log(update.data);
          setLoader1(false);
          // history.push('/dashboard/transactions')
          // setLoading(false)
          window.location.reload();
        } else if (update.error) {
          console.log(update.error);
          setLoader1(false);
        }
      };
      updateApplication(item.value.token);
    }
    getWithExpiry("userData");
  };

  return (
    <div className={styles.main}>
      <div className={styles.secondSection}>
        <div className={styles.secondInsideBox}>
          {loading ? (
            <div className={styles.loader}>
              <div className="spinner-border" role="status"></div>
            </div>
          ) : data.length === 0 ? (
            <div className={styles.lengthCont}>
              <h2 className={styles.contHead}>{error}</h2>
            </div>
          ) : (
            <>
              <TableContainer
                component={Paper}
                style={{ boxShadow: "none" }}
                className={styles.allTable}
              >
                <Table aria-label="caption table"  ref={printRef}>
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">
                        <div className={styles.tableHead}>Invoice ID</div>
                      </TableCell>
                      <TableCell align="center">
                        <div className={styles.tableHead}>Date</div>
                      </TableCell>
                      <TableCell align="center">
                        <div className={styles.tableHead}>Amount</div>
                      </TableCell>
                      <TableCell align="center">
                        <div className={styles.tableHead}>Method</div>
                      </TableCell>
                      <TableCell align="center">
                        <div className={styles.tableHead}>Status</div>
                      </TableCell>
                      <TableCell align="center"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.map((value, index) => (
                      <TableRow key={index}>
                        <TableCell
                          className={styles.tableInHead}
                          align="center"
                        >
                          <div className={styles.tableInHead1}>
                            {value.country}
                            <Tooltip
                              title={
                                <span className={styles.details1}>
                                  {value.id}
                                </span>
                              }
                              arrow
                              placement="bottom"
                            >
                              <p className={styles.details}>
                                #{value.id.substring(0, 7)}
                              </p>
                            </Tooltip>
                          </div>
                        </TableCell>
                        <TableCell
                          className={styles.tableInHead}
                          align="center"
                        >
                          <div className={styles.tableInHead1}>
                            {moment(new Date(value.date)).format("DD/MM/YYYY")}
                            <p className={styles.details}>
                              {new Date(value.date).toLocaleTimeString(
                                navigator.language,
                                {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                }
                              )}
                            </p>
                          </div>
                        </TableCell>
                        <TableCell
                          className={styles.tableInHead}
                          align="center"
                        >
                          <div className={styles.tableInHead2}>
                            <b>₦ {value.cost.toLocaleString()}</b>
                          </div>
                        </TableCell>
                        <TableCell
                          className={styles.tableInHead}
                          align="center"
                        >
                          <div className={styles.tableInHead1}>
                            {value.payment.toLowerCase()}
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className={styles.tableInHeadTemp}>
                            {value.status === "PAID" ? (
                              <p className={styles.paid}>Completed</p>
                            ) : (
                              <p className={styles.unpaid}>
                                {value.status.toLowerCase()}
                              </p>
                            )}
                          </div>
                        </TableCell>
                        <TableCell
                          className={styles.tableInHead}
                          align="center"
                        >
                          <div>
                            <MDBDropdown>
                              <MDBDropdownToggle
                                className={styles.toggle}
                                color="transparent"
                              >
                                <BiDotsVerticalRounded size={25} />
                              </MDBDropdownToggle>

                              <MDBDropdownMenu basic>
                                {value.status === "UNPAID" ? (
                                  ((error === "No Transactions Was Canceled.") || value.status2 === "CANCELLED") ? (
                                    <MDBDropdownItem disabled> No Action</MDBDropdownItem>
                                  ) : (
                                    <>
                                      <MDBDropdownItem>
                                        <Link
                                          to={`/dashboard/transactions/payment/${value.id}`}
                                          style={{ color: "black" }}
                                        >
                                          <img src={confirmation} />{" "}
                                          &nbsp;&nbsp; Confirm Payment
                                        </Link>
                                      </MDBDropdownItem>
                                      <MDBDropdownItem divider />
                                      <MDBDropdownItem
                                        onClick={() =>
                                          cancelTRansaction(value.id)
                                        }
                                      >
                                        <img src={cancel} /> &nbsp;&nbsp; Cancel
                                        transaction
                                      </MDBDropdownItem>
                                    </>
                                  )
                                ) : (
                                  <MDBDropdownItem onClick={handlePrint}>
                                    &nbsp;&nbsp;
                                    <img src={print} /> &nbsp;&nbsp;
                                    &nbsp;&nbsp; Print Invoice &nbsp;&nbsp;
                                    &nbsp;&nbsp; &nbsp;&nbsp;
                                  </MDBDropdownItem>
                                )}
                              </MDBDropdownMenu>
                            </MDBDropdown>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <div className={styles.allTableMobile}>
                <div className={styles.allDataMobile}>
                  <h2 className={styles.headMobile}>Invoice ID</h2>
                  <h2 className={styles.headMobile}>Amount</h2>
                  <h2 className={styles.headMobile}>Status</h2>
                  {/* <h2 className={styles.headMobile}>&nbsp;&nbsp;&nbsp;&nbsp;</h2> */}
                </div>
                {/* <hr /> */}
                {data.map((value, index) => (
                  <div key={index}>
                    <hr className={styles.lineMobile} />

                    <div className={styles.boxMobile}>
                      <div className={styles.boxInMobile}>
                        <span className={styles.nameMobile}>
                          {value.country}
                        </span>
                        <br />
                        <Tooltip
                          title={
                            <span className={styles.details1}>{value.id}</span>
                          }
                          arrow
                          placement="bottom"
                        >
                          <span className={styles.idMobile}>
                            #{value.id.substring(0, 7)}
                            <br />
                          </span>
                        </Tooltip>
                        <span className={styles.dateTimeMobile}>
                          {moment(new Date(value.date)).format("DD/MM/YYYY")}
                          <br />
                          <div>
                          {new Date(value.date).toLocaleTimeString(
                                navigator.language,
                                {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                }
                              )}
                          </div>
                        </span>
                      </div>
                      <div className={styles.boxInMobile}>
                        <span className={styles.nameMobile}>
                          <b>₦ {value.cost.toLocaleString()}</b>
                        </span>
                        <br />
                        <span className={styles.paymentMobile}>
                          {value.payment.toLowerCase()}
                        </span>
                      </div>
                      <div className={styles.check}>
                        <span>
                          {value.status === "PAID" ? (
                            <span className={styles.paid}>Completed</span>
                          ) : (
                            <span className={styles.unpaid}>
                              {value.status.toLowerCase()}
                            </span>
                          )}
                        </span>

                        <span>
                          <MDBDropdown>
                            <MDBDropdownToggle
                              className={styles.toggle}
                              color="transparent"
                            >
                              <BiDotsVerticalRounded size={20} />
                            </MDBDropdownToggle>

                            <MDBDropdownMenu basic className={styles.dropdown}>
                              {value.status === "UNPAID" ? (
                                ((error === "No Transactions Was Canceled.") || value.status2 === "CANCELLED") ? (
                                  <MDBDropdownItem disabled>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; No Action &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</MDBDropdownItem>
                                ) : (
                                  <>
                                    <MDBDropdownItem>
                                      <Link
                                        to={`/dashboard/transactions/payment/${value.id}`}
                                        style={{ color: "black" }}
                                      >
                                        <img src={confirmation} /> &nbsp;&nbsp;
                                        Confirm Payment
                                      </Link>
                                    </MDBDropdownItem>
                                    <MDBDropdownItem divider />
                                    <MDBDropdownItem
                                      onClick={() =>
                                        cancelTRansaction(value.id)
                                      }
                                    >
                                      <img src={cancel} /> &nbsp;&nbsp; Cancel
                                      transaction
                                    </MDBDropdownItem>
                                  </>
                                )
                              ) : (
                                <MDBDropdownItem onClick={handlePrint}>
                                  &nbsp;&nbsp;
                                  <img src={print} /> &nbsp;&nbsp; &nbsp;&nbsp;
                                  Print Invoice &nbsp;&nbsp; &nbsp;&nbsp;
                                  &nbsp;&nbsp;
                                </MDBDropdownItem>
                              )}
                            </MDBDropdownMenu>
                          </MDBDropdown>
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
